import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Slider } from 'react-burgers';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';

import {
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from 'store/themeOptions/actions';

const AppMobileMenu = () => {
  const dispatch = useDispatch();
  const enableMobileMenu = useSelector(
    state => state.themeOption.enableMobileMenu
  );
  const enableMobileMenuSmall = useSelector(
    state => state.themeOption.enableMobileMenuSmall
  );

  return (
    <>
      <div className="app-header__mobile-menu">
        <div onClick={() => dispatch(setEnableMobileMenu(!enableMobileMenu))}>
          <Slider
            active={enableMobileMenu}
            type="elastic"
            onClick={() => dispatch(setEnableMobileMenu(!enableMobileMenu))}
          />
        </div>
      </div>
      <div className="app-header__menu">
        <span
          onClick={() =>
            dispatch(setEnableMobileMenuSmall(!enableMobileMenuSmall))
          }
        >
          <Button
            size="sm"
            className={cx('btn-icon btn-icon-only', {
              active: enableMobileMenuSmall,
            })}
            color="primary"
            onClick={() =>
              dispatch(setEnableMobileMenuSmall(!enableMobileMenuSmall))
            }
          >
            <div className="btn-icon-wrapper">
              <FontAwesomeIcon icon={faEllipsisV} />
            </div>
          </Button>
        </span>
      </div>
    </>
  );
};

export default AppMobileMenu;
